module.exports = __webpack_public_path__ + "img/icon11.e485eda2.png";